import React from 'react';
import { Checkbox, message } from 'antd';
import { Link } from 'react-router-dom';

/**
 * 登录/注册共用的协议勾选（参考无悠志愿上架合规实现）
 */
const AgreementConsent = ({ checked, onChange, style }) => (
  <div style={{ marginBottom: 16, ...style }}>
    <Checkbox checked={checked} onChange={(e) => onChange(e.target.checked)}>
      <span style={{ fontSize: 13, color: '#666' }}>
        我已阅读并同意
        <Link to="/privacy" target="_blank" rel="noopener noreferrer">《隐私政策》</Link>
        和
        <Link to="/terms" target="_blank" rel="noopener noreferrer">《用户协议》</Link>
      </span>
    </Checkbox>
  </div>
);

export const requireAgreement = (agreed, showMessage = message.warning) => {
  if (!agreed) {
    showMessage('请先勾选并同意《隐私政策》和《用户协议》');
    return false;
  }
  return true;
};

export default AgreementConsent;
